import { createBrowserRouter } from 'react-router-dom'

import { ProtectedRoute, SystemContainer } from '../components'
import { ForgotUserkeyPage, LoginPage, LoginSsoPage, RegisterPoliceholderPage } from '../pages'
import CompanySelectionPage from '../pages/company/CompanyPage'
import HomePageContent from '../pages/homeContent/HomeContentPage'
import HomePage from '../pages/HomePage'
import ManagementPage from '../pages/management/ManagementPage'
import MessagePage from '../pages/message/MessagePage'
import NotFoundPage from '../pages/notfound/NotFoundPage'
import PrevidenciaPage from '../pages/previdencia/PrevidenciaPage'
import ProfilePage from '../pages/profile/ProfilePage'
import ReportsPage from '../pages/reports/ReportsPage'
import SaudePage from '../pages/saude/SaudePage'
import UnauthorizedPage from '../pages/unauthorized/UnauthorizedPage'
import VidaPage from '../pages/vida/VidaPage'
import WebVidaPage from '../pages/webVida/WebVida'
import { getBaseUrl } from '../utils/routeUtils'

import { ROUTES } from './routesConfig'

// Helper function to create protected routes with SystemContainer
const createProtectedSystemRoute = (path: string, element: React.ReactElement) => ({
    path,
    element: <ProtectedRoute><SystemContainer /></ProtectedRoute>,
    children: [
        {
            path: '',
            element,
        },
    ],
});

const routes = createBrowserRouter([
    {
        path: ROUTES.LOGIN,
        element: <LoginPage />,
    },
    {
        path: ROUTES.LOGIN_SSO,
        element: <LoginSsoPage />,
    },
    {
        path: ROUTES.FORGOT_USERKEY,
        element: <ForgotUserkeyPage />,
    },
    {
        path: ROUTES.UNAUTHORIZED,
        element: <UnauthorizedPage />,
    },
    {
        path: '*',
        element: <NotFoundPage />,
    },
    {
        path: ROUTES.COMPANY,
        element: <ProtectedRoute><CompanySelectionPage /></ProtectedRoute>,
    },
    {
        path: ROUTES.HOME,
        element: <ProtectedRoute><HomePage /></ProtectedRoute>,
        children: [
            createProtectedSystemRoute('', <HomePageContent />),
            createProtectedSystemRoute(ROUTES.HOME_ALT, <HomePageContent />),
            createProtectedSystemRoute(ROUTES.PREVIDENCIA, <PrevidenciaPage />),
            createProtectedSystemRoute(ROUTES.SAUDE, <SaudePage />),
            createProtectedSystemRoute(ROUTES.VIDA, <VidaPage />),
            createProtectedSystemRoute(ROUTES.PROFILE, <ProfilePage />),
            createProtectedSystemRoute(ROUTES.REGISTER_POLICEHOLDER, <RegisterPoliceholderPage />),
            createProtectedSystemRoute(ROUTES.MESSAGE, <MessagePage />),
            createProtectedSystemRoute(ROUTES.WEB_VIDA, <WebVidaPage />),
            createProtectedSystemRoute(ROUTES.MANAGEMENT, <ManagementPage />),
            createProtectedSystemRoute(ROUTES.REPORTS, <ReportsPage />),
        ],
    },
], {
    basename: getBaseUrl().replace(/\/$/, '') // Remove trailing slash for basename
});

export default routes;